// extracted by mini-css-extract-plugin
export default {"content":"TermsForBuyer_content__cQEF3"};